import { Button, Form, Image, Col, InputGroup, Spinner } from "react-bootstrap";
import React, { Component } from "react";
import "../styles/Colour_Style.css";
import "../styles/Form_Style.css";
import { useForm, ErrorMessage } from "react-hook-form";
import { condensingWhitespace, handleNumberInput, handleTextInput } from "../logic/FormInput_Logic";
import { useState } from "react";
import { aset } from "../logic/handler";

function FormDataAsetFunCom(props) {
  const {
    register,
    errors,
    handleSubmit,
    clearError,
    setError,
    setValue,
    getValues,
  } = useForm({
    mode: "all",
    validateCriteriaMode: "all",
    defaultValues: {
      goods_type: props.location.state ? props.location.state.goods_type : "",
      description: props.location.state ? props.location.state.description : "",
      issue_date: props.location.state
        ? props.location.state.issue_date.substring(0, 10)
        : "",
      expired_date: props.location.state
        ? props.location.state.expired_date.substring(0, 10)
        : "",
      no_certificate: props.location.state
        ? props.location.state.no_certificate
        : "",
      cost: props.location.state ? props.location.state.cost : "",
      service_name: props.location.state
        ? props.location.state.service_name
        : "",
      contact: props.location.state ? props.location.state.contact : "",
      memo: props.location.state ? props.location.state.memo : "",
    },
  });

  const [state, setState] = useState({
    edit: props.location.state ? true : false,
    loading: false,
    editExpireDate: ""
  });

  const handleChange = (event) => {
    let val = "";
    if (
      event.target.name === "contact" ||
      event.target.name === "cost"
    )
      val = handleNumberInput(event);
    else val = handleTextInput(event.target.name, event);
    setValue(event.target.name, val);
  };

  const submit = async (value) => {
    setState({
      ...state,
      loading: true,
    });
    value._id = props.location.state ? props.location.state._id : null;
    value = condensingWhitespace(value)
    let success = false;
    let resp = await aset(
      localStorage.getItem("token"),
      value,
      state.edit ? "put" : "post"
    );
    if (resp[0]) {
      if (resp[0].status === 200) success = true;
      else {
      }
    } else {
      if (Array.isArray(resp[1].data)) {
        for (const key in resp[1].data) {
          props.generateToast(
            1,
            "Status " + resp[1].status + ": " + resp[1].data[key].msg
          );
        }
      } else
        props.generateToast(
          1,
          "Status " + resp[1].status + ": " + resp[1].message
        );
    }
    setState({
      ...state,
      loading: false,
    });
    if (success) props.showModal(state.edit ? "edit" : "input", resp[0].data);
  };

  return (
    <div className="container">
      {state.edit && (
        <h4>
          Sedang mengedit aset
          <b>
            {" "}
            No. {props.location.state.no}: {props.location.state.goods_type}
          </b>
        </h4>
      )}
      <Form className="form" onSubmit={handleSubmit(submit)}>
        <Form.Row>
          {/* <Form.Group as={Col}>
            <Form.Label>No :</Form.Label>
            <Form.Control name="name" type="text" readOnly defaultValue={"1"} />
          </Form.Group> */}
          <Form.Group as={Col}>
            <Form.Label for="phone">Jenis Barang :</Form.Label>
            <Form.Control
              type="text"
              name="goods_type"
              ref={register({ required: "Input tidak boleh kosong" })}
              description
              onChange={handleChange}
            />
            <ErrorMessage errors={errors} name="goods_type">
              {({ message }) => <p className="error_info">{message}</p>}
            </ErrorMessage>
          </Form.Group>
        </Form.Row>
        <Form.Group>
          <Form.Label>Deskripsi :</Form.Label>
          <Form.Control
            type="text"
            name="description"
            ref={register({ required: "Input tidak boleh kosong" })}
          />
          <ErrorMessage errors={errors} name="description">
            {({ message }) => <p className="error_info">{message}</p>}
          </ErrorMessage>
        </Form.Group>
        <Form.Row>
          <Form.Group as={Col}>
            <Form.Label>Tanggal Terbit :</Form.Label>
            <Form.Control
              name="issue_date"
              type="date"
              ref={register({ required: "Input tidak boleh kosong" })}
              onChange={(e)=>{
                let expire = getValues("expired_date");
                if(expire){
                  if(e.target.value > expire){
                    setValue("expired_date",e.target.value)
                  }
                }
                setState({...state, editExpireDate: e.target.value})
              }}
            />
            <ErrorMessage errors={errors} name="issue_date">
              {({ message }) => <p className="error_info">{message}</p>}
            </ErrorMessage>
          </Form.Group>
          <Form.Group as={Col}>
            <Form.Label>Tanggal Expired :</Form.Label>
            <Form.Control
              type="date"
              name="expired_date"
              ref={register({ 
                  required: "Input tidak boleh kosong",
                  validate: {
                    valid: value => value >= getValues("issue_date") || 'Input harus lebih besar dari tanggal terbit',
                  } 
                })}
              disabled={!state.editExpireDate}
              min={state.editExpireDate}
            />
            <ErrorMessage errors={errors} name="expired_date">
              {({ message }) => <p className="error_info">{message}</p>}
            </ErrorMessage>
          </Form.Group>
        </Form.Row>
        <Form.Group>
          <Form.Label>No Surat/Sertifikat :</Form.Label>
          <Form.Control
            type="text"
            name="no_certificate"
            ref={register({ required: "Input tidak boleh kosong" })}
            onChange={handleChange}
          />
        </Form.Group>
        <ErrorMessage errors={errors} name="no_certificate">
          {({ message }) => <p className="error_info">{message}</p>}
        </ErrorMessage>
        <Form.Row>
          <Form.Group as={Col} sm={5}>
            <Form.Label>Biaya:</Form.Label>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text>Rp.</InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                type="text"
                name="cost"
                ref={register({ required: "Input tidak boleh kosong" })}
                onChange={handleChange}
              />
            </InputGroup>
            <ErrorMessage errors={errors} name="cost">
              {({ message }) => <p className="error_info">{message}</p>}
            </ErrorMessage>
          </Form.Group>
          <Form.Group as={Col} sm={7}>
            <Form.Label>Nama Jasa:</Form.Label>
            <Form.Control
              type="text"
              name="service_name"
              ref={register({ required: "Input tidak boleh kosong" })}
              onChange={handleChange}
            />
            <ErrorMessage errors={errors} name="service_name">
              {({ message }) => <p className="error_info">{message}</p>}
            </ErrorMessage>
          </Form.Group>
        </Form.Row>
        <Form.Group>
          <Form.Label>Contact Person :</Form.Label>
          <Form.Control
            type="tel"
            name="contact"
            ref={register({
              required: "Input tidak boleh kosong",
              pattern: {
                value: /^[+-]?\d+$/,
                message:
                  "Format salah, contoh yang benar: +6221222333 / 021222333",
              },
              maxLength: {
                value: 16,
                message: "Nomor terlalu panjang, maksimal 16 digit",
              },
              minLength: {
                value: 8,
                message: "Nomor terlalu pendek, minimal 8 digit",
              },
            })}
            onChange={handleChange}
          />
          <ErrorMessage errors={errors} name="contact">
            {({ message }) => <p className="error_info">{message}</p>}
          </ErrorMessage>
        </Form.Group>
        <Form.Group>
          <Form.Label>Memo :</Form.Label>
          <Form.Control
            style={{ minHeight: 100 }}
            as="textarea"
            name="memo"
            ref={register({ required: "Input tidak boleh kosong" })}
          />
          <ErrorMessage errors={errors} name="memo">
            {({ message }) => <p className="error_info">{message}</p>}
          </ErrorMessage>
        </Form.Group>
        <div className="btn-container">
          <Button variant="primary" type="submit" disabled={state.loading}>
            {state.loading ? <Spinner animation="border" variant="secondary"/> : "Save"}
          </Button>
        </div>
      </Form>
    </div>
  );
}

export default FormDataAsetFunCom;
